import React from 'react';

import { StepProps, track } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { Box, Button, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import { RequestValues } from './Controller';

import Footer from '../Shared/components/Footer';
import { locationAssign } from '../Shared/path-helpers';

const ProspectRequestCreationError: React.FC<React.PropsWithChildren<StepProps<RequestValues>>> = ({
  flowState: { returnToPath, values },
}) => {
  const onClick = () => {
    if (values.eligibilityError) {
      track('ElementClicked', { name: 'GotIt', flow: 'OpenJointCheckingPrimary' });
    }
    locationAssign(returnToPath);
  };

  return (
    <CenteredWorkflowLayout title="Joint Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box mb="8">
          <Icon name="ExclamationCircle" size="large" color="icon" />
        </Box>
        <Heading as="h1" variant="primary">
          {values.eligibilityError?.title || 'Something went wrong'}
        </Heading>
        <Box mb="9">
          <Text as="p">
            {values.eligibilityError?.message || "We weren't able to capture that information. Please try again."}
          </Text>
        </Box>
        <CenteredWorkflowLayout.Actions>
          <Button type="button" px="8" onClick={onClick}>
            {values.eligibilityError ? 'Got it' : 'Try again'}
          </Button>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default ProspectRequestCreationError;
